import { Route } from '@angular/router';
import { IsAuthenticatedGuard } from '@principle-theorem/ng-auth';

export const appRoutes: Route[] = [
  {
    path: 'login',
    data: { title: 'Login' },
    loadComponent: () =>
      import('./pages/auth-page/auth-page.component').then(
        (mod) => mod.AuthPageComponent
      ),
  },
  {
    path: 'account-action',
    loadComponent: () =>
      import(
        './pages/account-actions-page/account-actions-page.component'
      ).then((mod) => mod.AccountActionsPageComponent),
  },
  {
    path: 'unauthorised',
    canActivate: [IsAuthenticatedGuard],
    loadComponent: () =>
      import('@principle-theorem/ng-principle/pages').then(
        (mod) => mod.UnauthorisedComponent
      ),
  },
  {
    title: 'Principle Referrals',
    path: '',
    canActivate: [IsAuthenticatedGuard],
    loadComponent: () =>
      import('./layout/main/main.component').then((mod) => mod.MainComponent),
    children: [
      {
        path: '',
        redirectTo: 'referrals',
        pathMatch: 'full',
      },
      {
        path: 'referrals',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@principle-theorem/ng-referral').then(
                (mod) => mod.ReferralPortalDashboardComponent
              ),
          },
          {
            path: ':referralUid',
            loadComponent: () =>
              import('@principle-theorem/ng-referral').then(
                (mod) => mod.ReferralPortalComponent
              ),
          },
        ],
      },
    ],
  },
];
